<div class="loader">
  <div class="animate"></div>
  @if (!!text) {
    <div
      class="animate-text">
      <span>{{ text }}</span>
    </div>
  }
</div>
